import * as React from 'react';
import {FunctionComponent} from 'react';
import {CalendarMode} from '../EventCalendarPresenter';
import {CalendarEvent} from '../../../../Models/CalendarEvent';
import {FullCrew} from '../../../../Models/Crew';
import {BigScreenModes} from './BigScreenModes';
import {MobileCalendar} from './MobileCalendar/MobileCalendar';
import {Me} from '../../../../Models/Me';
import {PartialWorkout} from '../../../../Models/PartialWorkout';

interface OwnProps {
    me: Me;
    mode: CalendarMode;
    referenceDate: Date;
    ownWorkouts: PartialWorkout[];
    calendarEvents: CalendarEvent[];
    crews: FullCrew[];
    onCalendarEventDateChange: (calendarEvent: CalendarEvent, date: Date) => void;
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
    onCreateClick: (date: Date) => void;
}

export const Modes: FunctionComponent<OwnProps> = ({
    me,
    mode,
    referenceDate,
    ownWorkouts,
    calendarEvents,
    crews,
    onCalendarEventDateChange,
    onCalendarEventClick,
    onCreateClick,
}) => {
    return (
        <>
            <div className="d-block d-sm-none">
                <MobileCalendar
                    me={me}
                    referenceDate={referenceDate}
                    calendarEvents={calendarEvents}
                    onCalendarEventClick={onCalendarEventClick}
                    onCreateClick={onCreateClick}
                />
            </div>
            <div className="d-none d-sm-block">
                <BigScreenModes
                    mode={mode}
                    referenceDate={referenceDate}
                    ownWorkouts={ownWorkouts}
                    calendarEvents={calendarEvents}
                    crews={crews}
                    onCalendarEventDateChange={onCalendarEventDateChange}
                    onCalendarEventClick={onCalendarEventClick}
                    onCreateClick={onCreateClick}
                />
            </div>
        </>
    );
};
